import { backtestSteps } from './backtestSteps'
import { alertSteps } from './alertSteps'
import { patternBuilderSteps } from './patternBuilderSteps'
import { TutorialStep } from '../types'

export { backtestSteps, alertSteps, patternBuilderSteps }

export const getSteps = (
  context: 'patternBuilder' | 'backtest' | 'alerts' | string
): readonly TutorialStep[] => {
  switch (context) {
    case 'backtest':
      return backtestSteps
    case 'alerts':
      return alertSteps
    case 'patternBuilder':
      return patternBuilderSteps
    default:
      return []
  }
}
